import { Injectable, Inject } from '@angular/core';
import { BaseApi } from '../abstracts';
import {
  API_CONFIGURATION_TOKEN,
  ApiConfiguration
} from '../tokens/api.configuration';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtService } from '@ecosure-suite/shared/util-auth';


@Injectable({
  providedIn: 'root'
})
export class FileStorageApiService {
  server: string;
  constructor(
    @Inject(API_CONFIGURATION_TOKEN) configuration: ApiConfiguration,
    http: HttpClient, private jwtService: JwtService
  ) {
    this.server = configuration.file_storage_uri;
  }

  private headers = new HttpHeaders({
    Accept: 'application/json',
    'Content-Type': `application/json`
  }).append('Authorization', `Bearer ${this.jwtService.getToken()}`);

  getFile(fileId){
    return `${this.server}/${fileId}/download`;
  }

  getReport(url){
    return url;
  }
}
